// extracted by mini-css-extract-plugin
export default {"zoomControls":"waa-z","zoomControlButton":"xaa-z","zoomBanner":"yaa-z","bannerButton":"zaa-z","imageButton":"Aaa-z","zoom":"Baa-z","zoomContent":"Caa-z"};